// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"756":"a2052f31353c064b","2988":"2ac702a5cef895f1","4628":"7e767d279854ffcf","5997":"92031265b1d98aae","6087":"14d00d047d803121"}[chunkId] + ".css";
};